import React from 'react';
import "./LoginView.css";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from '../../slices/authSlice';

function LoginView({ onLogin }) {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [isError, setError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (isError) setError(false);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    const { username, password } = formData;

    if (username === 'admin' && password === 'admin') {
      setError(false);
      localStorage.setItem('authenticated', true);
      dispatch(login());
      navigate('/');
    } else {
      setError(true);
    }
  };

  return (
    <div className='loginView'>
      <div className='login-section'>
        <div className='login-header'>
          <img
            className='login-logo'
            src={require("../../assets/images/svgs/geodata-logo.svg").default}
            alt='geodata-logo'
          />
          <div className='login-heading'>Geodata</div>
        </div>
        <form onSubmit={handleLogin}>
          <div className='login-title bottomBorder'>Login</div>
          {isError &&
            <div className='login-error'>
              Invalid Credentials
            </div>
          }
          <div className='login-field-section'>
            <label>Username: <span className='required'>*</span></label>
            <input
              className={`login-field ${isError ? 'invalid-field' : ''}`}
              type="text"
              name="username"
              placeholder='please enter username'
              value={formData.username}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </div>
          <div className='login-field-section'>
            <label>Password: <span className='required'>*</span></label>
            <input
              className={`login-field ${isError ? 'invalid-field' : ''}`}
              type="password"
              name="password"
              placeholder='please enter password'
              value={formData.password}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </div>
          <div className='login-actions'>
            <button
              className='btn btn-primary login-button'
              disabled={!formData.username || !formData.password}
              type="submit"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginView;
